export const PAY_HOST = 'https://pay.gasbuddy.com/';
